<template>
    <div class="activity-content nfbz-container">
        
        <div class="activity-nfbz-title">
              年费标准
              <a href="javascript:;" class="go-back activity-back" @click="e=>this.$router.back()"></a>
        </div>
        <div class="nfbz-table-wrapper">
            
            <img src="../../assets/images/nfbz-table-1@2x.png" alt="">
            
        </div>
        <div class="activity-nfbz-title">
            其他费用
        </div>
        <div class="nfbz-table-wrapper">
           <img src="../../assets/images/nfbz-table-2@2x.png" alt="">
        </div>
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style lang="scss" scoped>

</style>